import styled from 'styled-components';

export type IStyledCandivore2ProductProps = {
  textColor: string;
};

export const StyledCandivore2MainProduct = styled.div<IStyledCandivore2ProductProps>`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;

  .container-image {
    width: 64px;
    height: 64px;
    display: flex;
    align-items: end;

    .image {
      width: 100%;
      height: auto;
      max-height: 95%;
      object-fit: contain;
    }
  }

  .container-amount {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center!important;
    bottom: 5px;

    .amount {
      text-shadow: 0 1px 1px #000;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      display: flex;
      align-items: center!important;
      color: ${({ textColor }) => textColor};
      width: 100%;

      .prefix-image {
        width: 16px;
        height: auto;
        margin-right: 4px;
      }

      &-prefix {
        text-shadow: 0 1px 1px #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: ${({ textColor }) => textColor};
        padding: 1px 8px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 30px;
        text-align: center;
        width: 100%;
      }
    }

    .stroked {
      color: #fff;
      text-align: center;
      text-shadow: 0 1px 1px #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-decoration-line: line-through;
      text-decoration-color: #e24070;
      text-decoration-thickness: 1px;
    }

    .autoTextSize {
      display: flex!important;
      align-items: center;
      justify-content: center;
      padding: 0 5px;
      width: 100%
    }
  }
`;
